// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/source/api/source_sync_operation.proto (package gx.source.api, syntax proto3)
/* eslint-disable */

import { SourceSyncOperationService } from "./source_sync_operation_pb.js";

/**
 * @generated from rpc gx.source.api.SourceSyncOperationService.CreateSourceSyncOperation
 */
export const createSourceSyncOperation = SourceSyncOperationService.method.createSourceSyncOperation;

/**
 * @generated from rpc gx.source.api.SourceSyncOperationService.GetSourceSyncOperation
 */
export const getSourceSyncOperation = SourceSyncOperationService.method.getSourceSyncOperation;

/**
 * @generated from rpc gx.source.api.SourceSyncOperationService.ListSourceSyncOperations
 */
export const listSourceSyncOperations = SourceSyncOperationService.method.listSourceSyncOperations;

/**
 * @generated from rpc gx.source.api.SourceSyncOperationService.UpdateSourceSyncOperation
 */
export const updateSourceSyncOperation = SourceSyncOperationService.method.updateSourceSyncOperation;

/**
 * @generated from rpc gx.source.api.SourceSyncOperationService.CountSourceSyncOperations
 */
export const countSourceSyncOperations = SourceSyncOperationService.method.countSourceSyncOperations;
